'use strict';

function Week5ResidentialCareTypeFactory(RespiteCareType, constants) {

  function Week5ResidentialCareType(userInputModel) {
    var respiteCareType = new RespiteCareType(userInputModel);

    this.getTotalWeeklyExpenses = function () {
      return respiteCareType.getTotalWeeklyExpenses();
    };

    this.getPartnerMinimumIncomeGuarantee = function (results) {
      return respiteCareType.getPartnerMinimumIncomeGuarantee(results);
    };

    this.personalLivingAllowance = function (results) {
      return respiteCareType.personalLivingAllowance(results);
    };

    this.getDisregardedAttendanceAllowance = function () {
      return respiteCareType.getDisregardedAttendanceAllowance();
    };

    this.getDisregardedPrivatePension = function () {
      return respiteCareType.getDisregardedPrivatePension();
    };

    this.getDisregardedCarersPremium = function (isEntitledToPremium, carersAllowance) {
      return respiteCareType.getDisregardedCarersPremium(isEntitledToPremium, carersAllowance);
    };

    this.getChildrensPremium = function () {
      return respiteCareType.getChildrensPremium();
    };

    this.getDisregardedPensionSavingsCredit = function (userType, results) {
      var respiteValue = respiteCareType.getDisregardedPensionSavingsCredit(userType, results);
      return Math.min(constants.pensionCreditAllowances.maxDisregardSingle, respiteValue);
    };

    this.getAllowableWorkingTaxCredit = function (workingTaxCreditIncome) {
      return userInputModel.isCouple() ? workingTaxCreditIncome / 2 : workingTaxCreditIncome;
    };

    function getQualifyingIncome(workings) {
      var applicantData = userInputModel.getApplicantData();

      var qualifyingIncome = [
        'earningsFromPaidEmployment',
        'privatePension',
        'retirementPension',
        'warPension',
        'warDisablementPension',
        'carersAllowance',
        'workingTaxCredit',
        'otherBenefit',
        'universalCredit'
      ].reduce(
        function (runningTotal, incomeType) {
          return runningTotal + applicantData.getWeeklyIncome(incomeType);
        }, 0
      );

      qualifyingIncome += workings.user.capitalTariff;
      return qualifyingIncome;
    }

    /**
     * https://docs.google.com/spreadsheets/d/18IC99SA-bWsKc5J-oxatnQ756-iw64A8GuQD_oF37Xs/edit#gid=0
     *
     * @param contributionUpperBound
     * @param workings
     */
    this.adjustContribution = function (contributionUpperBound, workings) {

      var applicantData = userInputModel.getApplicantData();
      var hasPartner = userInputModel.isCouple();

      var livesAlone = !userInputModel.isCouple() && !userInputModel.dependentChildrenLivingInProperty() &&
        !userInputModel.otherPeopleLivingInProperty();
      var attendanceAllowance = applicantData.getWeeklyIncome('attendanceAllowance');
      var pensionGuaranteeCredit = applicantData.getWeeklyIncome('pensionGuaranteeCredit');

      // KERP-3191, KERP-3193
      if (livesAlone && attendanceAllowance >= constants.attendanceAllowance.medium.amount) {

        // KERP-3213 See comment about qualifying income
        var income = getQualifyingIncome(workings);
        var incomeThreshold = 167.25;

        // KERP-3249
        var disabilityDisregard = 0;

        if (income > incomeThreshold) {
          disabilityDisregard = Math.min(constants.severeDisabilityPremium, pensionGuaranteeCredit);

        } else if (pensionGuaranteeCredit >= constants.severeDisabilityPremium) {
          disabilityDisregard = constants.severeDisabilityPremium;
        }

        contributionUpperBound -= disabilityDisregard;
      }

      // KERP-3249 https://lookinglocal.slack.com/archives/G1NH7QRK8/p1561031093035700
      workings.user.disregards -= applicantData.getWeeklyIncome('attendanceAllowance');

      var housingCosts = ['rent', 'councilTax', 'waterRates', 'homeContentsInsurance', 'groundRent'].reduce(
        function (runningTotal, expenseType) {
          return runningTotal + userInputModel.getWeeklyExpense(expenseType);
        }, 0);

      housingCosts = hasPartner ? housingCosts / 2 : housingCosts;

      contributionUpperBound += housingCosts;

      var savingsThreshold = constants.residential.totalSavingsThreshold;
      var individualCapital = applicantData.individualCapital + (0.5 * userInputModel.getJointCapital());

      return individualCapital >= savingsThreshold || applicantData.hasAdditionalProperties ?
        constants.maxWeeklyContribution : contributionUpperBound;
    };
  }

  return Week5ResidentialCareType;
}

Week5ResidentialCareTypeFactory.$inject = ['RespiteCareType', 'kirkleesCareAssessmentConstants'];

angular.module('kerp-forms.forms').factory('Week5ResidentialCareType', Week5ResidentialCareTypeFactory);
